export default __webpack_public_path__ + "static/media/Linkedin Learning Network+ prep 1 Understanding Networks.d0df3e26.webp";